<!--关联账户-->
<template lang="pug">
    el-dialog(title="关联账户", width="40%", :visible.sync='visible' :append-to-body="true" @close="closeForm()")
        el-form(:model="addLinkFrom" ref="linkform" :rules="LinkFromRule" label-width='110px')
            el-form-item(label="姓名:"  prop="name")
                el-input.inputWidth_g(type="text" v-model="addLinkFrom.name" disabled)
            el-form-item(label="身份证号:" prop="idCard")
                el-input.inputWidth_g(type="text" v-model="addLinkFrom.idCard" disabled)
            el-form-item(label="关联账号:" prop="account")
                el-input.inputWidth_g(type="text" v-model="addLinkFrom.account" @blur='changeAccount')
            el-form-item(label="关联会员:" prop="linkPerson")
                el-input.inputWidth_g(type="text" v-model="addLinkFrom.linkPerson" @blur='changeAccount')
            el-row(style='margin-top:30px;')
        span.dialog-footer(slot="footer")
            el-button(type="primary" @click="addLink") 确 定
            el-button(@click="closeForm()") 取 消
</template>
<script>
import { isMobile } from '../../../../util/validate'
export default {
  name: 'UpdateGrade',
  data () {
    return {
      visible: false,
      coach: null,
      addLinkFrom: {
        name: '',
        idCard: '',
        linkPerson: '',
        account: ''
      },
      LinkFromRule: {
        account: [
          { required: true, message: '必须填写关联账户!', trigger: 'blur' }
        ],
        linkPerson: [
          { required: true, message: '必须填写会员!', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    addLink () {
      this.$refs.linkform.validate((v) => {
        if (v) {
          console.log(this.addLinkFrom)
          if (this.addLinkFrom.account && isMobile(this.addLinkFrom.account)) {
            this.openFullScreen()
            this.$http({
              url: this.$http.adornUrl(`/mbMember/getMbByMobile`),
              method: 'get',
              params: this.$http.adornParams({
                mobile: this.addLinkFrom.account,
                name: this.addLinkFrom.linkPerson
              })
            }).then((data) => {
              if (data && data.code === 0) {
                if (data.list != null && data.list.length > 0) {
                  this.coach.byx1 = data.list[0].id
                  this.$http({
                    url: this.$http.adornUrl(`/ctReferee/updateReferee`),
                    method: 'post',
                    data: this.coach
                  }).then((data) => {
                    if (data && data.code === 0) {
                      this.$message({
                        message: '操作成功',
                        type: 'success',
                        duration: 1500,
                        onClose: () => {
                          this.linkFormVisible = false
                          // this.getDataList()
                          this.$emit('getDataList')
                          this.loading.close()
                          this.visible = false
                        }
                      })
                    } else {
                      this.$message.error(data.msg)
                      this.loading.close()
                      // this.visible = false
                    }
                  })
                } else {
                  this.$message.error('未找到会员信息')
                  this.loading.close()
                  // this.visible = false
                }
              }
            })
          }
        }
      })
    },
    openFullScreen () {
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    init (row) {
      console.log(row)
      this.visible = true
      this.coach = row
      this.addLinkFrom.name = row.name
      this.addLinkFrom.idCard = row.code
      this.addLinkFrom.linkPerson = ''
      this.addLinkFrom.account = ''
      if (row.byx1) {
        //根据会员id查询会员信息
        this.$http({
          url: this.$http.adornUrl(`/mbMember/getId/${row.byx1}`),
          method: 'get',
          params: this.$http.adornParams()
        }).then((data) => {
          console.log('初始化信息', data)
          if (data && data.code === 0) {
            this.addLinkFrom.linkPerson = data.bean.name
            this.addLinkFrom.account = data.bean.mobile
          }
        })
      }
    },
    changeAccount () {
      if (this.addLinkFrom.account && isMobile(this.addLinkFrom.account)) {
        this.$http({
          url: this.$http.adornUrl(`/mbMember/getMbByMobile`),
          method: 'get',
          params: this.$http.adornParams({
            mobile: this.addLinkFrom.account,
            name: this.addLinkFrom.linkPerson
          })
        }).then((data) => {
          if (data && data.code === 0) {
            if (data.list != null && data.list.length > 0) {
            } else {
              this.$message.error('未找到会员信息')
            }
          }
        })
      }
    },
    closeForm () {
      this.visible = false
    }
  }
}
</script>
<style>
.inputWidth {
  width: 200px;
}
.inputWidth_g {
  width: 90%;
}
</style>
